module.exports = __webpack_public_path__ + "img/PetsOutlined.a789e06a.svg";